import { render, staticRenderFns } from "./PageVisits.vue?vue&type=template&id=4c5dd456&scoped=true&"
import script from "./PageVisits.vue?vue&type=script&lang=js&"
export * from "./PageVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5dd456",
  null
  
)

export default component.exports